import React, { Fragment, useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import { changeBotActivation } from "../redux/actions";
const chatBotUrl = process.env.REACT_APP_CHATBOT_URL;
function ChatBot({
    gid,
    pageSetting,
    botActivation,
    mobile,
    propertyId,
    changeBotActivation,
    botIntegrationData,
    parent_location,
    parent_referrer,
    open,
    isValid,
    botOpeningLoader_Stop,
    selectedProperty
}) {
    // const [botCode, setBotCode] = useState({});
    // useEffect(() => {
    //     if (pageSetting !== undefined && pageSetting !== null && pageSetting.chatBot !== null) {
    //         setBotCode({
    //             disabled: pageSetting.chatBot.botDisabled,
    //             iid: pageSetting.chatBot.botIntegrationId
    //         });
    //     }
    // }, [pageSetting]);
    var pID = propertyId !== undefined && propertyId !== "-1" ? propertyId : selectedProperty !== null ? selectedProperty.pid : "";
    // if (gid === "d39a6ebb-1ca3-4f60-8e7f-ae9900185e7a") {
    //     pID = "3a82bdfb-c4cf-4b59-a0ce-ae990018a6f3";
    // }
    var script = `<!-- This is start of the Book Me Bob digital assistant code -->
       <script>       
       var BMB_BOT_domain = '${chatBotUrl === undefined ? "" : chatBotUrl}/';
       var BMB_BOT_botHTMLPath = BMB_BOT_domain + 'index.html';
       var BMB_BOT_head = document.getElementsByTagName('head')[0];
       var BMB_BOT_script = document.createElement('script');
       BMB_BOT_script.type = 'text/javascript';
       BMB_BOT_script.src = BMB_BOT_domain + 'chatplugin.js';
       BMB_BOT_head.appendChild(BMB_BOT_script);
       var BMB_BOT_gid = '${gid}';
       var BMB_BOT_iid = '${botIntegrationData !== null && botIntegrationData.iid !== undefined && selectedProperty === null ? botIntegrationData.iid : selectedProperty !== null ? selectedProperty.iid : ""}';
       var BMB_BOT_pid = '${pID}';
       var BMB_SERVICE_VIEW=true;
       var BMB_MOBILE=${mobile};
       var BMB_MYMA_MESSENGER = true;
       var BMB_MYMA_LOCATION ='${parent_location}';
       var BMB_MYMA_REFERRER ='${parent_referrer}';
       var BMB_OPEN ='${open}';
     </script>
 <!-- This is end of the Book Me Bob digital assistant code -->`;
    const InjectScript = (({ script }) => {
        const divRef = useRef(null);
        useEffect(() => {
            if (divRef.current === null) {
                return;
            }
            // create a contextual fragment that will execute the script
            // beware of security concerns!!
            const doc = document
                .createRange()
                .createContextualFragment(script);

            // clear the div HTML, and append the doc fragment with the script 
            divRef.current.innerHTML = '';
            divRef.current.id = "testScriptName";
            divRef.current.appendChild(doc);
            changeBotActivation("true");
            // if (botOpeningLoader_Stop !== undefined) {
            //     console.log("JHJ");
            //     setTimeout(() => {
            //         botOpeningLoader_Stop();
            //     }, 1000);
            // }
        });
        return <div ref={divRef} />
    });
    return (
        <Fragment>
            {/* {botIntegrationData.disabled === true ?
                "" :
                botActivation === "false" &&
                <InjectScript script={script}></InjectScript>
            } */}
          <div className="chat_bot_window"> {isValid &&
                <InjectScript script={script}></InjectScript>
            }</div> 
        </Fragment>
    );
}
const mapStateToProps = ({ messenger }) => {
    const { botActivation } = messenger;
    return { botActivation };
};
export default connect(mapStateToProps, { changeBotActivation })(ChatBot);
